export enum CRMDashboardEnum {
  NEW_ENQUIRY,
  ALL_ENQUIRY,
  ALL_ENQUIRY_CREATED_BY,
  ALL_SALES_CREATED_BY,
  ASSIGNED_ENQUIRY,
  FOLLOW_UPS,
  CANCELLED_ENQUIRY,
  CONFIRMED_SALES,
  ALL_SALES,
  ASSIGNED_SALES,
  FOLLOWUP_SALES,
  CANCELLED_SALES,
  CLOSED_SALES,
  PENDING_PAYMENT,
  PENDING_CONFIRMATION_ENQUIRY,
  PENDING_CONFIRMATION_SALES
}

export enum TaskStatDashboardEnum {
  NEW ,
  ASSIGNED ,
  FOLLOW_UP ,
  CANCELLED ,
  COMPLETED ,
  CONFIRM ,
  CREATED,
  ALL,
}

export enum DisconnectionDashboardEnum {
  ALL_REQUEST,
  PENDING_REQUEST,
  ASSIGN_REQUEST,
  FOLLOW_REQUEST,
  HOLD_REQUEST,
  NON_PAYMENT_REQUEST,
  DISCONNECTION_REQUEST,
  RETAINED_REQUEST,
  CREATED_REQUEST,
}

export enum CollectionDashboardEnum {
  COLLECTION,
  NO_COLLECTION,
  DISCONNECTION_REQUEST,
}

export enum PaymentStatusEnum {
  Received = "RECEIVED",
  Pending = "PENDING",
  Partially_Received = "PARTIALLY_RECEIVED"
}

export enum RecevingStatusEnum {
  Received = "RECEIVED",
  Pending = "PENDING",
  Partially_Received = "PARTIALLY_RECEIVED"
}

export enum EkycStatusEnum {
  New = "NEW",
  Approved = "APPROVED",
  Reject = "REJECT",
  Error = "ERROR"
}
export enum WorkStatusEnum {
  Wiring = "WIRING",
  Approved = "APPROVED",
  Reject = "REJECT",
  Installation = "INSTALLATION",
  Pending_Confirmation = "PENDING_CONFIRMATION",
  Closed = "CLOSED",
  New = "NEW",
  Error = "ERROR",
  RE_UPDATE = "RE_UPDATE",
}
export enum EkycWorkStatusEnum {
  ALL = "ALL",
  PENDING_PAYMENT = "PENDING_PAYMENT",
  PENDING_APPROVAL = "PENDING_APPROVAL",
  PENDING_ACCOUNT = "PENDING_ACCOUNT",
  PENDING_WIRING = "PENDING_WIRING",
  PENDING_FIBRE = "PENDING_FIBRE",
  PENDING_ACCOUNT_WIRING = "PENDING_ACCOUNT_WIRING",
  PENDING_INSTALLATION = "PENDING_INSTALLATION",
  PENDING_CONFIRMATION = "PENDING_CONFIRMATION",
  REJECTED = "REJECTED",
  CLOSED = "CLOSED",
  PAYMENT_LATER = "PAYMENT_LATER",
  RE_UPDATE = "RE_UPDATE",
  CASH_PAYMENT_MODE = "CASH_PAYMENT_MODE",
  CHEQUE_PAYMENT_MODE = "CHEQUE_PAYMENT_MODE",
  ONLINE_PAYMENT_MODE = "ONLINE_PAYMENT_MODE",
  SWIPECARD_PAYMENT_MODE = "SWIPECARD_PAYMENT_MODE",
  NEFT_PAYMENT_MODE = "NEFT_PAYMENT_MODE",
  CABLE_TV = "CABLE_TV"

}

export enum EkycStatusEnum {
  ALL,
  PENDING_PAYMENT,
  PENDING_APPROVAL,
  PENDING_ACCOUNT,
  PENDING_WIRING,
  PENDING_ACCOUNT_WIRING,
  PENDING_INSTALLATION,
  PENDING_CONFIRMATION,
  REJECTED,
  PAYMENT_LATER,
  CLOSED,
  CASH_PAYMENT_MODE,
  CHEQUE_PAYMENT_MODE,
  ONLINE_PAYMENT_MODE,
  SWIPECARD_PAYMENT_MODE,
  NEFT_PAYMENT_MODE,

}

export enum ReasonsEnum {
  Disconnection = "Disconnection",
  Connection_Issue = "Connection Issue",
  Followup = "Followup"
}

export enum IssueDashboardEnum{
DISCONNECTION = "DISCONNECTION" ,
CONNECTION_ISSUE = "CONNECTION_ISSUE" ,
ACCOUNT_ISSUE = "ACCOUNT_ISSUE" 
}